"use client";

import { useContext } from "react";

import { ReactNativeAppContext } from "@/providers/ReactNativeAppProvider";

export function useIsReactNativeApp() {
  return useContext(ReactNativeAppContext);
}
